<template>
  <div class="inithomework">
    <div class="back"></div>
    <div class="main">
      <div class="main_inner">
        <template v-if="homeworkid=='null'">
          <left-panel></left-panel>
        </template>
        <template v-else>
          <left-panel-student :userid="userid" :studentsList="contentsList" @changeStudent="changeStudent"></left-panel-student>
        </template>
        <div class="right-content">
          <div class="chat-area">
            <chat-top :id="id" @sendhomework="sendhomework" :title="title" :rid="rid" :lessonid="lessonid" :classid="classid" :homeworkid="homeworkid"></chat-top>
            <scroll-wrapper :question="question" :reply="reply" :temp="temp" :answernum="answernum"
                            @deletemessage="deletemessage"></scroll-wrapper>
            <chat-bottom :id="id" :isFirstSent="isFirstSent" @sendmessage="receivemessage"></chat-bottom>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="发送成功"
      :visible.sync="sendShow"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%">
      <p style="font-size:20px;line-height:36px;margin-bottom:20px;">您可以使用微信“扫一扫”打开全优在线小程序发送作业给学生</p>
      <img style="display: block;margin: 0 auto;" :src="qrurl" alt="二维码" width="250" height="250">

      <button class="confirm" @click="quitEdit">返回作业管理</button>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import leftPanel from '@/components/homework/leftpanel'
  import leftPanelStudent from '@/components/homework/leftpanelWithStudent'
  import chatTop from '@/components/homework/tchattop'
  import scrollWrapper from '@/components/homework/tscrollwrapper'
  import chatBottom from '@/components/homework/tchatbottom'

  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        title: '',
        rid: '',
        lessonid: '',
        classid: '',
        homeworkid: '',
        worklevel:'',
        answernum: '',
        contentsList:[],
        question: [],    //作业题目
        userid:'',       //当前学生的userid
        reply: [],
        temp: [],
        isFirstSent: true,
        sendShow: false,
        qrurl:'',
      }
    },
    methods: {
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      deletemessage(index) {
        //如果当前没有学生回答
        if (this.answernum == '0') {
          if (index == 0) {
            if (this.question.length > 1) {
              this.question[1].time = this.question[0].time;
            } else {
              this.isFirstSent = true;
            }
          }
          this.question.splice(index, 1);
        }else{
          if (index == 0) {
            if (this.temp.length > 1) {
              this.temp[1].time = this.temp[0].time;
            } else {
              this.isFirstSent = true;
            }
          }
          this.temp.splice(index, 1);
        }
      },
      changeStudent(userid){
        this.userid=userid;
        this.isFirstSent = true;
        this.contentsList.forEach((ele)=>{
          if(ele.userid===userid){
            this.reply=this.transform(ele.reply);
            this.temp=[];
          }
        })
      },
      receivemessage(value) {
        if (this.answernum == '0') {
          this.question.push(value);
        } else {
          this.temp.push(value);
        }
        this.isFirstSent = false;
      },
      QueryHomeWorkContent(classid, homeworkid) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'HomeWork',
            a: 'QueryHomeWorkContent',
            id: this.id,
            classid: classid,
            homeworkid: homeworkid
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let list = response.list[0]
            this.answernum=list.answernum;
            this.question = this.transform(list.question);
            this.contentsList=list.content;
            if(this.userid==''){
              this.userid=this.contentsList[0].userid;
              this.reply = this.transform(this.contentsList[0].reply);
            }else{
              list.content.forEach((ele)=>{
                if(ele.userid===this.userid){
                  this.reply = this.transform(ele.reply);
                }
              })
            }

            this.$forceUpdate();
          }
        }).catch((err) => {

        });
      },
      transform(list) {
        try {
          JSON.parse(decodeURIComponent(list))
          return JSON.parse(decodeURIComponent(list))
        }
        catch (err) {
          return []
        }
      },
      quitEdit() {
        this.$router.replace('/console/homework/undone')
      },
      computeUpList(list) {
        if (this.isEmpty(list)) {
          return '';
        } else {
          let result = JSON.stringify(list);
          result = encodeURIComponent(result);
          return result;
        }
      },
      sendhomework() {
        //发送作业有3种情况：1.classworkid为'null'(注意是字符串，因为解析),则是创建作业； 2.classworkid不为'null'，isanswer为'0'，证明学生没有回答，则修改的是question；3.classworkid不为'null'，isanswer为'1'，证明学生回答了问题，则修改的是replay
        if (this.homeworkid === 'null') {
          if (this.computeUpList(this.question) == '') {
            this.$message({
              message: '请输入作业题目',
              type: 'warning'
            })
            return;
          }
          this.AddClassWork();
        } else {
          if (this.answernum == '0') {
            if (this.computeUpList(this.question) == '') {
              this.$message({
                message: '请输入作业题目',
                type: 'warning'
              })
              return;
            }
            this.UpdateHomeWork();
          } else {
            if (this.computeUpList(this.temp) == '') {
              this.$message({
                message: '请输入回复信息',
                type: 'warning'
              })
              return;
            }
            this.UpdateHomeWorkContent();
          }
        }
      },
      AddClassWork() {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'HomeWork',
            a: 'AddHomeWork',
            id: this.id,
            classid: this.classid,
            title: this.title,
            question: this.computeUpList(this.question),
            worklevel:this.worklevel
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.homeworkid=response.homeworkid;
            this.GetCWxloginAGetwxqrcode();
            this.$forceUpdate();
          }
        }).catch((err) => {

        });
      },
      UpdateHomeWork(){
        let params = {
          c: 'HomeWork',
          a: 'UpdateHomeWork',
          id: this.id,
          classid: this.classid,
          homeworkid: this.homeworkid,
          question: this.computeUpList(this.question),
        };

        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.GetCWxloginAGetwxqrcode();
            this.$forceUpdate();
          }
        }).catch((err) => {

        });
      },
      UpdateHomeWorkContent() {
        let params = {
          c: 'HomeWork',
          a: 'UpdateHomeWorkContent',
          id: this.id,
          classid: this.classid,
          homeworkid: this.homeworkid,
          studentid:this.userid,
          reply : this.computeUpList(this.temp)
        };

        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.GetCWxloginAGetwxqrcode();
            this.$forceUpdate();
          }
        }).catch((err) => {

        });
      },
      GetCWxloginAGetwxqrcode(){
        let params = {
          c: 'WxLogin',
          a: 'getWXQRCode',
          page: 'pages/sharefromweb/sharefromweb',
          scene:this.rid+'-'+this.lessonid+'-'+this.classid+'-'+this.homeworkid
        };

        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.sendShow = true;
            this.qrurl=response.QRCode;
          }
        }).catch((err) => {

        });
      }

    },
    created() {
      this.title = decodeURIComponent(this.$utils.getUrlKey('title'));
      this.classid = decodeURIComponent(this.$utils.getUrlKey('classid'));
      this.rid = decodeURIComponent(this.$utils.getUrlKey('rid'));
      this.lessonid = decodeURIComponent(this.$utils.getUrlKey('lessonid'));
      this.homeworkid = decodeURIComponent(this.$utils.getUrlKey('homeworkid'));
      this.answernum = '0';   //先默认将answernum置为0（针对新建课程），如是编辑，再根据实际情况更新
      this.worklevel = decodeURIComponent(this.$utils.getUrlKey('worklevel'));
      //根据homeworkid判断是新建还是修改
      if (this.homeworkid != 'null') {
        this.QueryHomeWorkContent(this.classid, this.homeworkid);
      }

    },
    components: {
      leftPanel,
      leftPanelStudent,
      chatTop,
      scrollWrapper,
      chatBottom
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .inithomework {
    height: 100%;
    .back {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: url('./background.png') no-repeat 50%;
      background-size: cover;
    }
  }

  .main {
    height: 80%;
    min-height: 600px;
    padding-top: 100px;
    -webkit-transition: padding .3s linear;
    .main_inner {
      max-width: 1000px;
      min-width: 800px;
      height: 100%;
      margin: 0 auto;
      border-radius: 3px;
      overflow: hidden;
      background: #fff
      .right-content {
        height: 100%;
        .chat-area {
          position: relative;
          height: 100%;
          overflow: hidden;
        }
      }
    }
  }

  @media (max-height: 800px), (max-width: 1000px) {
    .main {
      padding-top: 0;
      height: 100%;
    }
  }
  .cancel, .confirm {
    display: block;
    margin:20px auto;
    width: 106px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 15px;
    color: #fff;
    border-radius: 4px;
  }
  .cancel {
    margin-right: 20px;
    background: #ccc;
  }
  .confirm {
    background: #3399ff;
    &:hover {
      background: #5eaefe
    }
  }
  .hint-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.3)
    z-index: 1000
    font-size: 0
    &::after {
      content: "";
      display: inline-block;
      height: 100%;
      width: 0;
      vertical-align: middle;
    }
    .sendhint {
      display: inline-block;
      padding: 40px 0 0;
      width: 400px;
      height: 290px;
      vertical-align: middle;
      background-color: #fff;
      border-radius: 6px;
      overflow: hidden;
      box-sizing: border-box
      .img-wrapper {
        margin-bottom: 20px;
        height: 50px;
        text-align: center
      }
      .send-title {
        font-size: 16px;
        color: #333;
        height: 22px;
        line-height: 22px;
        margin-bottom: 10px;
      }
      .hint-text {
        margin: 0 70px 20px;
        font-size: 14px;
        color: #a5a5a5;
        line-height: 22px;
      }
      .back-btn {
        display: inline-block;
        font-size: 15px;
        color: #fff;
        width: 250px;
        height: 36px;
        line-height: 36px;
        background: #3399ff;
        border-radius: 4px;
        &:hover {
          background: #5eaefe
        }
      }
      .cancel, .confirm {
        display: inline-block;
        width: 106px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 15px;
        color: #fff;
        border-radius: 4px;
      }
      .cancel {
        margin-right: 20px;
        background: #ccc;
      }
      .confirm {
        background: #3399ff;
        &:hover {
          background: #5eaefe
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/homework/homeworkinit/homeworkinit.vue